import React, { memo, useCallback } from 'react'
import { Button } from '@mui/material'
import { isProduction } from 'services/environment'
import { masqAsUser } from 'services/masq'
import { trackError } from 'services/analytics'
import { useFragment } from 'react-relay/hooks'
import { graphql } from 'relay-runtime'
import { MasqButton_User$key } from '__generated__/MasqButton_User.graphql'

interface IMaskButtonProps {
  userFragmentRef: MasqButton_User$key | null
}

function MasqButton({ userFragmentRef }: IMaskButtonProps) {
  const user = useFragment(graphql`
    fragment MasqButton_User on User {
      ...masq_masqAsUser
    }
  `, userFragmentRef)

  const masq = useCallback(async () => {
    try {
      await masqAsUser(user ?? null)
    } catch (error) {
      trackError(error)
    }
  }, [user])

  if (!isProduction() && user) {
    return (
      <Button onClick={masq}>
        MASQ
      </Button>
    )
  }

  return null
}

export default memo(MasqButton)
